import {createStore, combineReducers, applyMiddleware} from "redux";
import thunk from "redux-thunk";
import {composeWithDevTools} from "redux-devtools-extension";
import {bookingTypeReducer, getTripReducer, getTripRoomsReducer} from "./reducers/tripReducer";
import {stepReducer} from "./reducers/stepReducer";
import {transactionReducer} from "./reducers/transactionReducer";
import {
    setParkFeeReducer,
    setPortFeeReducer,
    setTaxReducer,
    setTotalsExtrasReducer,
    setTotalsReducer
} from "./reducers/totalReducer";
import {getActivitiesReducer, setActivitiesOptionReducer} from "./reducers/activitiesReducer";
import {getBookingFormReducer} from "./reducers/bookingFormReducer";

const reducer = combineReducers({
    step: stepReducer,
    bookingType: bookingTypeReducer,
    trip: getTripReducer,
    rooms: getTripRoomsReducer,
    activities: getActivitiesReducer,
    activitiesOption: setActivitiesOptionReducer,
    transactions: transactionReducer,
    parkFee: setParkFeeReducer,
    portFee: setPortFeeReducer,
    tax: setTaxReducer,
    totals: setTotalsReducer,
    totalsExtras: setTotalsExtrasReducer,
    bookingForm: getBookingFormReducer,
});

const bookingType = sessionStorage.getItem('bookingType') || 'pay';
const activitiesOption = sessionStorage.getItem('activitiesOption') || 'all';
const initialState = {bookingType, activitiesOption};

const transactionsFromSession = sessionStorage.getItem('transactions');
if (transactionsFromSession)
    initialState['transactions'] = JSON.parse(transactionsFromSession);

const middleware = [thunk];

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;

